module.exports = __webpack_public_path__ + "img/19.588bf292.svg";